import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';

import { TIME_SLOTS, VISIT_AND_UNITS } from '../constants/actionTypes';

export default createReducer(['timeSlots'], (timeSlots = Map(), action) => {

    switch (action.type) {

        case VISIT_AND_UNITS.CLEAR:
        case TIME_SLOTS.REQUEST:
        case TIME_SLOTS.ERROR:
            return Map();

        case TIME_SLOTS.SUCCESS:
            return fromJS(action.timeSlots);

        default:
            break;
    }
    
    return timeSlots;
});